import { useGT } from 'gt-react';
import { useUserGroupsList } from 'src/api/rpc/hooks/organization/useUserGroups';
import { usePageSections } from 'src/api/rpc/hooks/page-sections/usePageSections';
import {
  buildPlacementOptions,
  type PagePlacementOption,
} from 'src/components/task-pages/pagePlacement';

export type PageEditorOption = { id: string; label: string };

/**
 * Picker options shared by the task page and agent page editors: the sidebar
 * placements (the org's own page sections plus the built-in section labels)
 * and the org's user groups (with the draft's current audience resolved to
 * option objects for the multi-select).
 */
export function usePageEditorOptions(audienceUserGroupIds: readonly string[]) {
  const gt = useGT();
  const { data: userGroups } = useUserGroupsList();
  const { data: pageSections } = usePageSections();

  const placementOptions: PagePlacementOption[] = buildPlacementOptions({
    pageSections: pageSections ?? [],
    customGroupLabel: gt('Your sections', {
      context:
        'sidebar section picker group heading for org-created page sections',
    }),
    builtInGroupLabel: gt('Built-in sections', {
      context:
        'sidebar section picker group heading for the built-in sidebar sections',
    }),
  });
  const groupOptions: PageEditorOption[] = (userGroups ?? []).map((g) => ({
    id: g.id,
    label: g.name,
  }));
  const audienceIds = new Set(audienceUserGroupIds);
  const selectedAudience = groupOptions.filter((o) => audienceIds.has(o.id));

  return { placementOptions, groupOptions, selectedAudience };
}
